import {
  ADMINISTRATIONFormEnum,
  ADMINISTRATIONFormEnumAR,
  ADMINISTRATIONFormEnumES,
  ADMINISTRATIONFormEnumTR,
  COAMFormEnum,
  COAMFormEnumAR,
  COAMFormEnumES,
  COAMFormEnumTR,
  EMMFormEnum,
  EMMFormEnumAR,
  EMMFormEnumES,
  EMMFormEnumTR,
  FMMFormEnum,
  FMMFormEnumAR,
  FMMFormEnumES,
  FMMFormEnumTR,
  LILLFormEnum,
  LILLFormEnumAR,
  LILLFormEnumES,
  LILLFormEnumTR,
  ODC2MFormEnum,
  ODC2MFormEnumAR,
  ODC2MFormEnumES,
  ODC2MFormEnumTR,
  OMMFormEnum,
  OMMFormEnumAR,
  OMMFormEnumES,
  OMMFormEnumTR,
  PPMFormEnum,
  PPMFormEnumAR,
  PPMFormEnumES,
  PPMFormEnumTR,
  RLSMFormEnum,
  RLSMFormEnumAR,
  RLSMFormEnumES,
  RLSMFormEnumTR,
  SSMFormEnum,
  SSMFormEnumAR,
  SSMFormEnumES,
  SSMFormEnumTR,
} from 'src/enums/form.enum';
import i18n from 'src/i18n';

export const getOMMFormEnum = () => {
  if (i18n.language === 'tr') {
    return OMMFormEnumTR;
  } else if (i18n.language === 'ar') {
    return OMMFormEnumAR;
  } else if (i18n.language === 'es') {
    return OMMFormEnumES;
  } else {
    return OMMFormEnum;
  }
};

export const getFMMFormEnum = () => {
  if (i18n.language === 'tr') {
    return FMMFormEnumTR;
  } else if (i18n.language === 'ar') {
    return FMMFormEnumAR;
  } else if (i18n.language === 'es') {
    return FMMFormEnumES;
  } else {
    return FMMFormEnum;
  }
};

export const getRLSMFormEnum = () => {
  if (i18n.language === 'tr') {
    return RLSMFormEnumTR;
  } else if (i18n.language === 'ar') {
    return RLSMFormEnumAR;
  } else if (i18n.language === 'es') {
    return RLSMFormEnumES;
  } else {
    return RLSMFormEnum;
  }
};

export const getEMMFormEnum = () => {
  if (i18n.language === 'tr') {
    return EMMFormEnumTR;
  } else if (i18n.language === 'ar') {
    return EMMFormEnumAR;
  } else if (i18n.language === 'es') {
    return EMMFormEnumES;
  } else {
    return EMMFormEnum;
  }
};

export const getLILLFormEnum = () => {
  if (i18n.language === 'tr') {
    return LILLFormEnumTR;
  } else if (i18n.language === 'ar') {
    return LILLFormEnumAR;
  } else if (i18n.language === 'es') {
    return LILLFormEnumES;
  } else {
    return LILLFormEnum;
  }
};

export const getSSMFormEnum = () => {
  if (i18n.language === 'tr') {
    return SSMFormEnumTR;
  } else if (i18n.language === 'ar') {
    return SSMFormEnumAR;
  } else if (i18n.language === 'es') {
    return SSMFormEnumES;
  } else {
    return SSMFormEnum;
  }
};

export const getPPMFormEnum = () => {
  if (i18n.language === 'tr') {
    return PPMFormEnumTR;
  } else if (i18n.language === 'ar') {
    return PPMFormEnumAR;
  } else if (i18n.language === 'es') {
    return PPMFormEnumES;
  } else {
    return PPMFormEnum;
  }
};

export const getADMINISTRATIONFormEnum = () => {
  if (i18n.language === 'tr') {
    return ADMINISTRATIONFormEnumTR;
  } else if (i18n.language === 'ar') {
    return ADMINISTRATIONFormEnumAR;
  } else if (i18n.language === 'es') {
    return ADMINISTRATIONFormEnumES;
  } else {
    return ADMINISTRATIONFormEnum;
  }
};

export const getODC2MFormEnum = () => {
  if (i18n.language === 'tr') {
    return ODC2MFormEnumTR;
  } else if (i18n.language === 'ar') {
    return ODC2MFormEnumAR;
  } else if (i18n.language === 'es') {
    return ODC2MFormEnumES;
  } else {
    return ODC2MFormEnum;
  }
};

export const getCOAMFormEnum = () => {
  if (i18n.language === 'tr') {
    return COAMFormEnumTR;
  } else if (i18n.language === 'ar') {
    return COAMFormEnumAR;
  } else if (i18n.language === 'es') {
    return COAMFormEnumES;
  } else {
    return COAMFormEnum;
  }
};
